/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.75 9a.75.75 0 0 1 0-1.5h2.1554c-.5642-.5281-1.1452-1.0361-1.755-1.5-.365-.2778-.7404-.5397-1.1286-.7807-1.512-.9388-3.219-1.56-5.2718-1.56l-.0342.0001c-1.7671.0059-3.1815.4648-4.4223 1.189-1.482.8647-2.7161 2.1077-4.0076 3.4084-.1574.1585-.3156.3178-.4753.4774A.75.75 0 0 1 1.75 7.6736c-.0002.0001.0001-.0002 0 0 .1627-.1628.3262-.3277.49-.493 1.2538-1.265 2.5558-2.5786 4.1597-3.5449 1.4664-.8833 3.1852-1.4763 5.3503-1.4763 2.391 0 4.367.7344 6.0614 1.7846.5957.3692 1.1567.7774 1.6886 1.2065.5265.4247 1.0246.8699 1.5 1.3178V4.25a.75.75 0 0 1 1.5 0V9h-4.75Zm-15.8 6a.45.45 0 0 0-.45.45v5.1a.45.45 0 0 0 .45.45h2.1a.45.45 0 0 0 .45-.45v-5.1a.45.45 0 0 0-.45-.45h-2.1ZM0 15.45c0-1.077.873-1.95 1.95-1.95h2.1c1.077 0 1.95.873 1.95 1.95v5.1c0 1.0769-.873 1.95-1.95 1.95h-2.1C.873 22.5 0 21.6269 0 20.55v-5.1Zm13.5 0a.45.45 0 0 0-.45-.45h-2.1a.45.45 0 0 0-.45.45v5.1a.45.45 0 0 0 .45.45h2.1a.45.45 0 0 0 .45-.45v-5.1Zm-4.5 0c0-1.077.873-1.95 1.95-1.95h2.1c1.077 0 1.95.873 1.95 1.95v5.1c0 1.0769-.8731 1.95-1.95 1.95h-2.1C9.873 22.5 9 21.6269 9 20.55v-5.1ZM19.95 15a.45.45 0 0 0-.45.45v5.1a.45.45 0 0 0 .45.45h2.1a.45.45 0 0 0 .45-.45v-5.1a.45.45 0 0 0-.45-.45h-2.1Zm-1.95.45c0-1.077.873-1.95 1.95-1.95h2.1c1.077 0 1.95.873 1.95 1.95v5.1c0 1.0769-.8731 1.95-1.95 1.95h-2.1c-1.0769 0-1.95-.8731-1.95-1.95v-5.1Z"
    clipRule="evenodd"
  />,
  'Skip'
);
